//  Forms
import {
  inputReporterType,
  inputFirstName,
  inputLastName,
  inputRelationshipToPatient,
  inputPostcode,
  inputDateOfBirth,
  inputProblemDescription,
  inputProblemRecentContact,
  inputAdminRequest,
  inputVerificationCode,
  inputAttachments,
} from '../inputs';

// forms that use inputs
export const formReporterType = {
  config: {},
  fields: [inputReporterType],
};

export const formYourDetails = {
  config: {
    formTitle: 'Please fill in your details',
    hint: 'We use these details to contact you about this request.',
  },
  fields: [inputFirstName, inputLastName, inputRelationshipToPatient],
};

//  slight variation depend if user is patient or 'someone else'
export const formPatientDetailsYou = {
  config: {
    formTitle: 'Please fill in your details',
    hint: 'We use these details to find your patient record.',
  },
  fields: [inputFirstName, inputLastName, inputPostcode, inputDateOfBirth],
};

// slight variation depends if user is patient or 'someone else'
// NB, spread object first then add overrides
export const formPatientDetailsProxy = {
  ...formPatientDetailsYou,
  config: {
    formTitle: "Please fill in the patient's details",
    hint: 'We use these details to find their patient record.',
  },
};

export const formPatientProblemDetails = {
  config: {},
  fields: [inputProblemDescription, inputProblemRecentContact, inputAttachments],
};

export const formAdminRequestDetails = {
  fields: [inputAdminRequest, inputAttachments],
};

export const formVerificationCode = {
  config: {
    formTitle: 'Verification Code Sent',
    hint: 'We have sent a verification code to your email address or mobile phone.',
  },
  fields: [inputVerificationCode],
};
